import React, {useEffect, useState} from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import giftbg from "../assets/images/gift_bg.webp";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import lv9 from "../assets/images/lv9.webp";
import lv18 from "../assets/images/lv18.webp";
import { RxCrossCircled } from "react-icons/rx";

const Vip = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const {
    formState: { errors },
  } = useForm({});

  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  return (
    <LayoutNew>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 44 44"
            id="left"
          >
            <title>Operation Icons Copy 4</title>
            <defs>
              <path id="left_a" d="M-129-845h24v24h-24z"></path>
            </defs>
            <clipPath id="left_b">
              <use xlinkHref="#left_a" overflow="visible"></use>
            </clipPath>
            <g clipPath="url(#left_b)">
              <defs>
                <path id="left_c" d="M-903-949H947V996H-903z"></path>
              </defs>
              <clipPath id="left_d">
                <use xlinkHref="#left_c" overflow="visible"></use>
              </clipPath>
            </g>
            <path d="M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z"></path>
          </symbol>
          <symbol viewBox="0 0 30 30" id="go-icon_bc3c5dc5">
            <g id="go-icon_bc3c5dc5_icon-go">
              <path
                id="go-icon_bc3c5dc5_Vector"
                d="M16.0147 24.0124V18.8366H12.6831C8.0317 18.8366 4.00248 21.5067 2.03441 25.3839C1.85905 25.7294 1.34662 25.6766 1.23727 25.305C0.920988 24.2299 0.75 23.0864 0.75 21.9258C0.749999 15.3233 6.08052 9.99276 12.6831 9.99276H16.0147V4.81691C16.0147 4.45781 16.4275 4.2556 16.7112 4.47571L29.0829 14.0735C29.3057 14.2464 29.3057 14.583 29.0829 14.7559L16.7112 24.3536C16.4275 24.5737 16.0147 24.3715 16.0147 24.0124Z"
                fill="#434851"
              ></path>
            </g>
          </symbol>
          <symbol viewBox="0 0 142 142" id="bank-select-close_bab3216e">
            <g id="bank-select-close_bab3216e_Group 1261153217">
              <g
                id="bank-select-close_bab3216e_Ellipse 7"
                filter="url(#bank-select-close_bab3216e_filter0_d_1632_7938)"
              >
                <circle cx="71" cy="66" r="41" fill="#F2F2F2"></circle>
              </g>
              <path
                id="bank-select-close_bab3216e_Union"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M83.8741 54.1251C83.2884 53.5393 82.3386 53.5393 81.7528 54.1251L71.4998 64.3782L61.247 54.1253C60.6612 53.5396 59.7114 53.5396 59.1256 54.1253C58.5398 54.7111 58.5398 55.6609 59.1256 56.2467L69.3784 66.4995L59.1254 76.7525C58.5396 77.3383 58.5396 78.2881 59.1254 78.8738C59.7112 79.4596 60.6609 79.4596 61.2467 78.8738L71.4998 68.6208L81.753 78.8741C82.3388 79.4599 83.2886 79.4599 83.8744 78.8741C84.4602 78.2883 84.4602 77.3385 83.8744 76.7528L73.6211 66.4995L83.8741 56.2464C84.4599 55.6606 84.4599 54.7109 83.8741 54.1251Z"
                fill="#333333"
              ></path>
            </g>
            <defs>
              <filter
                id="bank-select-close_bab3216e_filter0_d_1632_7938"
                x="0"
                y="0"
                width="142"
                height="142"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                ></feColorMatrix>
                <feOffset dy="5"></feOffset>
                <feGaussianBlur stdDeviation="15"></feGaussianBlur>
                <feComposite in2="hardAlpha" operator="out"></feComposite>
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                ></feColorMatrix>
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1632_7938"
                ></feBlend>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_1632_7938"
                  result="shape"
                ></feBlend>
              </filter>
            </defs>
          </symbol>
        </defs>
      </svg>
      <div class="member-benefits customize" id="controlColor">
        <div class="mc-header-wrap">
          <div
            id="mc-header"
            class="mc-navbar-blue mc-benefits mc-default-header am-navbar am-navbar-light"
          >
            <div class="am-navbar-left" role="button">
              <span class="am-navbar-left-content">
                <span class="return_icon" onClick={() => navigate(-1)}>
                  <svg class="am-icon am-icon-left am-icon-lg">
                    <use xlinkHref="#left"></use>
                  </svg>
                </span>
              </span>
            </div>
            <div class="am-navbar-title"></div>
            <div class="am-navbar-right">
              <div class="vip-rule">Rules</div>
            </div>
          </div>
          <div class="am-whitespace am-whitespace-sm mc-whitespace"></div>
        </div>
        <div class="member-benefits-wrapper">
          <div class="member-level-info">
            <div class="level-info">
              <div class="level-img">
                <img src={lv9} alt="" />
              </div>
              <div class="label-name">VIP0</div>
            </div>
            <div class="level-btn" onClick={() => setModal(true)}>
              Upgrade
              <svg class="am-icon am-icon-go-icon_bc3c5dc5 am-icon-md">
                <use xlinkHref="#go-icon_bc3c5dc5"></use>
              </svg>
            </div>
          </div>

          <div class="upConditions-wrapper">
            <div class="benefits-title">Level Up Requirements</div>
            <div class="upConditions-subtitle">
              To level up, all conditions must be fulfilled
            </div>
            <div
              class="swiper-container upConditions-list-wrap swiper-container-initialized swiper-container-horizontal swiper-container-android"
              id="conditions-swiper"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide list-item swiper-slide-active">
                  <div class="item-name">
                    <img src={lv9} alt="" />
                    VIP0
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">138.00</div>
                      <div class="item-mid">/2,000.00</div>
                      <div class="item-bottom">6%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item next swiper-slide-next">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP1
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/20,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP2
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP3
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/300,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP4
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/700,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP5
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/1,200,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP6
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/2,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP7
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/5,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP8
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/8,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP9
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/12,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP10
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/20,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP11
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/40,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP12
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/70,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP13
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/100,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP14
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/130,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP15
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/160,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP16
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/200,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP17
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/250,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP18
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/300,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP19
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/340,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP20
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/380,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP21
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/420,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP22
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/480,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP23
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/540,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP24
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/620,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP25
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/700,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP26
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/800,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP27
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/900,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP28
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/1,000,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP29
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/1,200,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP30
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/1,500,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP31
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/2,000,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP32
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/2,500,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP33
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/3,000,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide list-item">
                  <div class="item-name">
                    <img src={lv18} alt="" />
                    VIP34
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top"></div>
                      <div class="item-mid">-</div>
                      <div class="item-bottom"></div>
                    </div>
                  </div>
                  <div>
                    <div class="item-info">
                      <div class="item-top">0.00</div>
                      <div class="item-mid">/4,000,000,000.00</div>
                      <div class="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-item default-title ">
                <div class="item-info">
                  <div class="item-top">Total deposit</div>
                </div>
                <div class="item-info">
                  <div class="item-top">Total bet</div>
                </div>
              </div>
              <div class="swiper-pagination swiper-pagination-bullets swiper-pagination-bullets-dynamic">
                <span
                  key="0"
                  class="swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main"
                ></span>
                <span
                  key="1"
                  class="swiper-pagination-bullet swiper-pagination-bullet-active-next"
                ></span>
                <span
                  key="2"
                  class="swiper-pagination-bullet swiper-pagination-bullet-active-next-next"
                ></span>
                <span key="3" class="swiper-pagination-bullet"></span>
                <span key="4" class="swiper-pagination-bullet"></span>
                <span key="5" class="swiper-pagination-bullet"></span>
                <span key="6" class="swiper-pagination-bullet"></span>
                <span key="7" class="swiper-pagination-bullet"></span>
                <span key="8" class="swiper-pagination-bullet"></span>
                <span key="9" class="swiper-pagination-bullet"></span>
                <span key="10" class="swiper-pagination-bullet"></span>
                <span key="11" class="swiper-pagination-bullet"></span>
                <span key="12" class="swiper-pagination-bullet"></span>
                <span key="13" class="swiper-pagination-bullet"></span>
                <span key="14" class="swiper-pagination-bullet"></span>
                <span key="15" class="swiper-pagination-bullet"></span>
                <span key="16" class="swiper-pagination-bullet"></span>
                <span key="17" class="swiper-pagination-bullet"></span>
                <span key="18" class="swiper-pagination-bullet"></span>
                <span key="19" class="swiper-pagination-bullet"></span>
                <span key="20" class="swiper-pagination-bullet"></span>
                <span key="21" class="swiper-pagination-bullet"></span>
                <span key="22" class="swiper-pagination-bullet"></span>
                <span key="23" class="swiper-pagination-bullet"></span>
                <span key="24" class="swiper-pagination-bullet"></span>
                <span key="25" class="swiper-pagination-bullet"></span>
                <span key="26" class="swiper-pagination-bullet"></span>
                <span key="27" class="swiper-pagination-bullet"></span>
                <span key="28" class="swiper-pagination-bullet"></span>
                <span key="29" class="swiper-pagination-bullet"></span>
                <span key="30" class="swiper-pagination-bullet"></span>
                <span key="31" class="swiper-pagination-bullet"></span>
                <span key="32" class="swiper-pagination-bullet"></span>
                <span key="33" class="swiper-pagination-bullet"></span>
                <span key="34" class="swiper-pagination-bullet"></span>
              </div>
              <span
                class="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              ></span>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <Modal centered show={modal} onHide={() => setModal(false)} className="am-popup-content">
          <Modal.Body>
            {/* <div>
              <RxCrossCircled
                size={20}
                color="white"
                onClick={() => setModal(false)}
              />
            </div> */}

            <div>
              <div class="am-popup-body">
                <div class="upgrade-wrap">
                  <div class="upgrade-list-wrap">
                    <div class="upgrade-top">
                      <div class="top-title">
                        <div class="title-item">Upgrade</div>
                        <div class="subtitle-item">
                          To level up, all conditions must be fulfilled
                        </div>
                      </div>
                      <div class="top-img">
                        <img src={lv9} alt="" />
                      </div>
                    </div>
                    <div class="upgrade-info-wrapper">
                      <div class="info-item">
                        <div class="task-text">Total deposit</div>
                        <div class="task-info-wrap">
                          <div class="task-progress">
                            <div class="task-view-info">
                              <span>৳ 0.00</span> /

                              <span class="target">100.00</span>
                            </div>
                            <div class="item-progress">
                              <div class="progress">
                                <div class="progress-done">
                                  <span></span>
                                </div>
                              </div>
                              <div class="current-progress">0%</div>
                            </div>
                          </div>
                          <div class="btn-task-status  ">GO</div>
                        </div>
                      </div>
                      <div class="info-item">
                        <div class="task-text">Total bet</div>
                        <div class="task-info-wrap">
                          <div class="task-progress">
                            <div class="task-view-info">
                              <span>৳ 138.00</span> /

                              <span class="target">2,000.00</span>
                            </div>
                            <div class="item-progress">
                              <div class="progress">
                                <div class="progress-done">
                                  <span></span>
                                </div>
                              </div>
                              <div class="current-progress">6%</div>
                            </div>
                          </div>
                          <div class="btn-task-status  ">GO</div>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
               <div class="upgrade-close"  onClick={() => setModal(false)}>
                    <svg class="am-icon am-icon-bank-select-close_bab3216e am-icon-md">
                      <use xlinkHref="#bank-select-close_bab3216e"></use>
                    </svg>
                  </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </LayoutNew>
  );
};

export default Vip;
